var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7C15.5523 7 16 7.44772 16 8V15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15V8C4 7.44772 4.44772 7 5 7H15Z",
    stroke: "#0DA1EC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5556 7C15.801 7 16 7.19898 16 7.44444V7.44444C16 9.40812 14.4081 11 12.4444 11H7.55556C5.59188 11 4 9.40812 4 7.44444V7.44444C4 7.19898 4.19898 7 4.44444 7H15.5556Z",
    stroke: "#0DA1EC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 4.44772 7.44772 4 8 4H12C12.5523 4 13 4.44772 13 5V7H7V5Z",
    stroke: "#0DA1EC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.5a683414a4d081f21a16b06d1b553aa5.svg";
export { ForwardRef as ReactComponent };